import {updateToolCall} from "../../../llm/contextManagement/toolCallUpdater.ts";
import {runOrQueueToolCall} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/handlers/appToolCallHandler/ide/ideToolCallHandler.ts";
import {addToolMessage} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/utils/utils.ts";
import {formatReviewChangesResults} from "./fileHandlerUtils.ts";
import { calcSlices } from 'fast-myers-diff';
import {getCodeReview} from "./utils/getCodeReview.ts";

export const handleGiveReviewChangesResults = async (data: any, llmRequestRefs: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any, updateElementInProgress: any, environmentObjRef: any, dynamicStateObjRef: any) => {
    try {
        const currentFileContents = JSON.parse(data[0]);
        const toolCallId = data[1];
        const task = data[2] ? JSON.parse(data[2]) : "";

        const { id, name, args } = llmRequestRefs.current.toolCalls[toolCallId];

        const diffResults: any = {};
        const unreviewedFiles = dynamicStateObjRef.current.unreviewedFileTracker;

        // Process each file in the unreviewedFileTracker
        for (const filePath in unreviewedFiles) {
            const fileTracker = unreviewedFiles[filePath];
            const operation = fileTracker.operation;

            // Handle different operations
            if (operation === "create") {
                diffResults[filePath] = {
                    operation: "create",
                    content: currentFileContents[filePath] || ""
                };
            }
            else if (operation === "delete") {
                diffResults[filePath] = {
                    operation: "delete"
                };
            }
            else if (operation === "move") {
                diffResults[filePath] = {
                    operation: "move",
                    originalFilePath: fileTracker.originalFilePath || filePath
                };
            }
            else if (operation === "edit") {
                // Calculate line-level diff for edited files
                const originalContent = fileTracker.originalContents || "";
                const currentContent = currentFileContents[filePath] || "";

                const originalLines = originalContent.split('\n');
                const currentLines = currentContent.split('\n');

                // Use calcSlices on lines instead of characters
                const slices = Array.from(calcSlices(originalLines, currentLines));

                diffResults[filePath] = slices.map(([type, lines]) => ({
                    value: lines,
                    added: type === 1,
                    removed: type === -1
                }));
            }
            else {
                // Fallback for unknown operations
                diffResults[filePath] = {
                    operation: operation || "unknown"
                };
            }
        }

        // Format the results for display
        const formattedData = formatReviewChangesResults(diffResults);
        const formattedFileStates = Object.entries(llmRequestRefs.current.additionalContext.mostRecentFileStates).map(([filePath, fileData]: [string, any]) => {
            return `File: ${filePath}\n\`\`\`${fileData.languageName}\n${fileData.fileContents}\n\`\`\``;
        });
        const codeReview = await getCodeReview(formattedFileStates, formattedData.textMessage, task);

        updateToolCall(llmRequestRefs, toolCallId, {formattedFiles: formattedData.files, codeReview});
        addToolMessage({ id, name, args }, { formattedResults: formattedData.textMessage, codeReview }, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);

        updateElementInProgress(toolCallId, 'delete');
        llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
        await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null, null);

    } catch (error) {
        console.error(error)
        // Still try to clean up the tool call if possible
        if (data[1] && llmRequestRefs.current.toolCalls[data[1]]) {
            updateElementInProgress(data[1], 'delete');
            llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== data[1]);
            await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null, null);
        }
    }
};